<template>

    <div class="progress-bar-item">

        <div class="progress-bar-step">

            <div class="progress-bar-indicator"
                 :class="{'active': step.active, 'complete': step.complete, 'disabled': step.disabled}"
                 @click="back"></div>
            <div class="mt-3 fw-bold"
                 :class="{'c-mid-dark-grey' : step.disabled,
                          'c-minstead-green' : step.complete,
                          'c-charcoal': step.active}">{{ step.name }}</div>

        </div>

    </div>

</template>

<script>

    export default {
        name: 'ProgressStep',
        props: {
            step: {
                required: true,
                type: Object
            }
        },

        methods: {

            /**
             * Emits event indicating we should navigate to this step
             */
            back() {
                if (!this.step.complete || this.step.disabled) return;
                this.$emit('request-step', this.step.index);
            }

        }

    }

</script>
